module.exports = __webpack_public_path__ + "img/6. HOMECARE, CAREPASS, HOOK.jpg";